import { ActionBase } from '../../../core/store/action/ActionBase';

export const ACTIVATE_DRAFT_DISCLAIMER_DESCRIPTION_SUCCESS_ACTION = '[Configuration] Messages Activate Draft Disclaimer Description Success Action';

export class ActivateDraftDisclaimerDescriptionSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ACTIVATE_DRAFT_DISCLAIMER_DESCRIPTION_SUCCESS_ACTION;

  constructor(public payload: { activatedDisclaimer: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/messages/store/actions/ActivateDraftDisclaimerDescriptionSuccessAction.ts